export const CLEAR_SESSION = 'CLEAR_SESSION'
export const SET_SESSION = 'SET_SESSION'
export const SET_USER = "SET_USER";

export const API = "API";
export const API_START = "API_START";
export const API_END = "API_END";
export const ACCESS_DENIED = "ACCESS_DENIED";
export const API_ERROR = "API_ERROR";



export const SET_USER_BOARD = "SET_USER_BOARD";
export const SET_USER_BOARDS = "SET_USER_BOARDS";
export const USER_BOARD_CREATED="USER_BOARD_CREATED";
export const USER_BOARD_UPDATED="USER_BOARD_UPDATED";
export const USER_BOARD_DELETED="USER_BOARD_DELETED";
export const USER_BOARD_IMAGES_LOADED="USER_BOARD_IMAGES_LOADED";
export const USER_BOARD_IMAGES_CREATED="USER_BOARD_IMAGES_CREATED";
export const USER_BOARD_IMAGE_DELETED = "USER_BOARD_IMAGE_DELETED";
export const USER_BOARDS_CLEARED = "USER_BOARDS_CLEARED"



export const SET_USER_SESSION='SET_USER_SESSION';
export const USER_SESSION_CREATED="USER_SESSION_CREATED";
export const USER_SESSION_CLEARED = 'USER_SESSION_CLEARED';
export const SET_USER_SESSIONS = "SET_USER_SESSIONS";
export const SESSION_CREATED = "SESSION_CREATED";
export const DELETE_USER_SESSION = "DELETE_USER_SESSION";
export const USER_SESSION_UPDATED="USER_SESSION_UPDATED"
export const USER_SESSION_DELETED="USER_SESSION_DELETED"
export const USER_SESSION_LOADED="USER_SESSION_LOADED";
export const USER_SESSION_IMAGES_LOADED="USER_SESSION_IMAGES_LOADED";
export const USER_SESSION_IMAGES_CREATED="USER_SESSION_IMAGES_CREATED";
export const USER_SESSION_IMAGE_DELETED = "USER_SESSION_IMAGE_DELETED";
export const USER_SESSION_CREATED_CLEARED="USER_SESSION_CREATED_CLEARED";
export const USER_SESSIONS_CLEARED="USER_SESSIONS_CLEARED";

export const SHAPERS_LOADED="SHAPERS_LOADED";
export const BOARDS_LOADED="BOARDS_LOADED";


export const USER_BOARD_CREATED_CLEARED="USER_BOARD_CREATED_CLEARED";

export const USER_LOGGED_IN="USER_LOGGED_IN";

export const USER_LOADED="USER_LOADED";

export const USER_IMAGE_UPDATED="USER_IMAGE_UPDATED";

export const USER_UPDATED="USER_UPDATED";

export const CONDITIONS_LOADED="CONDITIONS_LOADED";

export const USER_AVERAGES_LOADED = "USER_AVERAGES_LOADED";

export const BOARD_RATINGS_LOADED="BOARD_RATINGS_LOADED";
export const TOP_RATED_BOARDS_LOADED="TOP_RATED_BOARDS_LOADED";

export const SPOT_LOADED="SPOT_LOADED";
export const SPOT_CLEARED="SPOT_CLEARED";
export const SPOT_PHOTOS_LOADED="SPOT_PHOTOS_LOADED";
export const SPOT_NOTES_LOADED="SPOT_NOTES_LOADED";
export const SPOT_NOTE_CREATED="SPOT_NOTE_CREATED";
export const SPOT_NOTE_UPDATED="SPOT_NOTE_UPDATED";
export const SPOT_NOTE_DELETED="SPOT_NOTE_DELETED";
export const SPOT_DESCRIPTION_SAVED="SPOT_DESCRIPTION_SAVED";
export const SPOT_NOT_FOUND="SPOT_NOT_FOUND";
